import axios from 'axios';

import { UrlString } from 'types/UrlString';

export const getAbsoluteDownloadUrl = (url: UrlString) => {
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/')) return new URL(url, window.location.origin).toString();

  const apiBaseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  return new URL(url, new URL(apiBaseUrl, window.location.origin)).toString();
};

const downloadFromUrl = async (url: UrlString, name: string) => {
  const response = await axios.get(getAbsoluteDownloadUrl(url), { responseType: 'blob' });
  const blob = response.data;
  const urlCreator = window.URL || window.webkitURL;
  const imageUrl = urlCreator.createObjectURL(blob);
  const tag = document.createElement('a');
  tag.href = imageUrl;
  tag.download = name;
  document.body.appendChild(tag);
  tag.click();
  document.body.removeChild(tag);
};

export default downloadFromUrl;
